import { isEqual } from 'lodash';
import { MNTableContent } from '../../../../../../common/table/TableTypes';
import { createEmptyTableCellEntry } from '../../../../../../common/table/utils/tableInitialisationUtils';
import { getHotColWidthsGu } from '../columnSize/hotTableColWidthGetterUtils';
import { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Serializes the current Handsontable instance state into a format that can be persisted to the
 * Milanote DB (what we refer to as "raw data").
 */
export const convertHotInstanceToRaw = (hotInstance: MNHotInstance, gridSize: number): MNTableContent => {
    const colWidthsGU = getHotColWidthsGu(hotInstance, gridSize);
    const sourceData = hotInstance.getSourceDataArray();

    // NOTE: If we end up storing the column / row index mappings to redux state (WEB-15538), then the
    //  "visual -> physical" mapping below shouldn't be necessary
    const data = Array.from({ length: hotInstance.countRows() }, (_rowValue, visualRow) =>
        Array.from({ length: hotInstance.countCols() }, (_cellValue, visualCol) => {
            const physicalRow = hotInstance.toPhysicalRow(visualRow) ?? visualRow;
            const physicalCol = hotInstance.toPhysicalColumn(visualCol) ?? visualCol;
            const value = sourceData[physicalRow]?.[physicalCol] ?? null;
            const { cellData = createEmptyTableCellEntry() } = hotInstance.getCellMeta(visualRow, visualCol);

            return { ...cellData, value };
        }),
    );

    return {
        data,
        colWidthsGU,
    };
};

export const doesHotSnapshotMatchTableState = ({
    tableSnapshot,
    tableContentData,
    tableContentColWidthsGU,
}: {
    tableSnapshot: MNTableContent;
    tableContentData?: MNTableContent['data'];
    tableContentColWidthsGU?: MNTableContent['colWidthsGU'];
}): boolean =>
    isEqual(tableSnapshot.data, tableContentData) && isEqual(tableSnapshot.colWidthsGU, tableContentColWidthsGU);
